import { takeEvery, put, select, call } from 'redux-saga/effects';
import { setKeyForUser } from 'helpers/local-storage';
import { selectUserInfo } from 'selectors/general';
import { setDesktopCollapsed } from './reducers';
import { selectDesktopNavIsCollapsed } from './selectors';

export const LOCAL_STORAGE_KEY_DESKTOP_NAV_IS_COLLPASED = 'desktopNavIsCollapsed';

export const TOGGLE_DESKTOP_NAV_EXPAND_COLLAPSE = 'TOGGLE_DESKTOP_NAV_EXPAND_COLLAPSE';

export const toggleDesktopNavExpandCollapse = () => ({
  type: TOGGLE_DESKTOP_NAV_EXPAND_COLLAPSE,
});

export function* doToggleDesktopNavExpandCollapse() {
  const isCollapsed = yield select(selectDesktopNavIsCollapsed);
  const { userId } = yield select(selectUserInfo);
  yield put(setDesktopCollapsed(!isCollapsed));
  yield call(setKeyForUser, userId, LOCAL_STORAGE_KEY_DESKTOP_NAV_IS_COLLPASED, !isCollapsed);
}

export function* watchActions(client) {
  yield takeEvery(TOGGLE_DESKTOP_NAV_EXPAND_COLLAPSE, doToggleDesktopNavExpandCollapse, client);
}
